export default __webpack_public_path__ + "static/media/Compass.aa4474df.png";